import {
  PageTitle,
  PageTitleProps,
} from '@supplement-bacon/react-toolkit/components'
import ForbiddenPage from '@pages/ForbiddenPage'
import { Col, Row } from 'antd'
import { PropsWithChildren } from 'react'
import { HasAccessProps, useHasAccess } from '../HasAccess'

interface Props {
  permissions?: HasAccessProps['permissions']
  pageTitle?: PageTitleProps
  noWrapWithCol?: boolean
  rowGutter?: [number, number]
  rowClassName?: string
}

const Page = ({
  permissions,
  pageTitle,
  children,
  noWrapWithCol = false,
  rowGutter = [16, 16],
  rowClassName = '',
}: PropsWithChildren<Props>) => {
  const { hasAccess } = useHasAccess()

  // A page the admin may not open says so. Nothing else does anymore: a denied
  // request no longer evicts the app to /403, so this check — against the
  // admin's own permissions instead of whichever background request happened
  // to fail — is the page-level authorization feedback.
  //
  // Resolved synchronously rather than through <HasAccess>, whose state is
  // effect-based: it renders its fallback on the first paint, which would
  // flash the forbidden screen at admins who do have access.
  if (permissions && !hasAccess(permissions)) {
    return <ForbiddenPage />
  }

  return (
    <Row gutter={rowGutter} className={rowClassName}>
      {pageTitle && (
        <Col span={24}>
          <PageTitle {...pageTitle} />
        </Col>
      )}
      {noWrapWithCol === true ? children : <Col span={24}>{children}</Col>}
    </Row>
  )
}

export default Page
